<template>
  <v-container>
    <v-row>
      <v-col xs="12" md="12" sm="12">
        <v-card>
          <v-card-title>Профиль</v-card-title>

          <v-divider></v-divider>

          <v-card-text>
            <v-form>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-btn
                        variant="outlined"
                        @click="dialogs.password = true"
                    >
                      Изменить пароль
                    </v-btn>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col xs="12" md="4">
                    <div class="d-inline-block">
                      <v-text-field style="width: 100%"
                                    label="Email"
                                    :value="currentUser.email"
                                    disabled></v-text-field>
                    </div>
                    <v-btn class="mx-2"
                           color="green"
                           icon
                           small
                           depressed
                           title="Редактировать"
                           @click="dialogs.email = true"
                    >
                      <v-icon dark>
                        mdi-pencil
                      </v-icon>
                    </v-btn>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col xs="12" md="4">
                    <div class="d-inline-block">
                      <v-text-field style="width: 100%"
                                    label="Telegram ID"
                                    :value="currentUser.tg_chat_id"
                                    disabled></v-text-field>
                    </div>
                    <v-btn class="mx-2"
                           color="green"
                           icon
                           small
                           depressed
                           title="Редактировать"
                           @click="dialogs.telegram = true"
                    >
                      <v-icon dark>
                        mdi-pencil
                      </v-icon>
                    </v-btn>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col xs="12" md="4">
                    <div class="d-inline-block">
                      <v-text-field style="width: 100%"
                                    label="Номер телефона"
                                    :value="currentUser.phone_number"
                                    disabled></v-text-field>
                    </div>
                    <v-btn class="mx-2"
                           color="green"
                           icon
                           small
                           depressed
                           title="Редактировать"
                           @click="dialogs.phone_number = true"
                    >
                      <v-icon dark>
                        mdi-pencil
                      </v-icon>
                    </v-btn>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col xs="12" md="4">
                    Подтверждать вход через:
                    <v-radio-group v-model="auth_sender"
                                  @change="changeAuthSender(auth_sender)"
                                  :disabled="!currentUser.tg_chat_id || !currentUser.email">
                      <v-radio
                        label="E-mail"
                        value="mail"
                      ></v-radio>

                      <v-radio
                        label="Telegram"
                        value="telegram"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
              </v-container>

            </v-form>
          </v-card-text>

        </v-card>
      </v-col>
    </v-row>

    <ChangePasswordDialog v-model="dialogs.password"></ChangePasswordDialog>
    <ChangeEmailDialog v-model="dialogs.email"></ChangeEmailDialog>
    <ChangeTelegramDialog v-model="dialogs.telegram"></ChangeTelegramDialog>
    <ChangePhoneNumberDialog v-model="dialogs.phone_number"></ChangePhoneNumberDialog>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import ChangePasswordDialog from "~/components/partials/dialogs/ChangePasswordDialog";
import ChangeEmailDialog from "~/components/partials/dialogs/ChangeEmailDialog";
import ChangeTelegramDialog from "~/components/partials/dialogs/ChangeTelegramDialog";
import ChangePhoneNumberDialog from "~/components/partials/dialogs/ChangePhoneNumberDialog";

export default {
  components: {
    ChangePasswordDialog,
    ChangeEmailDialog,
    ChangeTelegramDialog,
    ChangePhoneNumberDialog,
  },
  data() {
    return {
      dialogs: {
        password: false,
        email: false,
        telegram: false,
        phone_number: false,
      },

      auth_sender: null,
    }
  },

  computed: {
    ...mapGetters('user', ['currentUser']),
  },

  methods: {
    ...mapActions({
      changeAuthSender: 'user/changeAuthSender',
    }),

    // changeSender() {
    //   this.changeAuthSender(this.auth_sender);
    // },
  },

  mounted() {
    this.auth_sender = this.currentUser.auth_sender;
  },
}
</script>

<style scoped>

</style>
